import { AUTHENTICATION } from "../auth/types";
import { AppStatePreloader, PreloaderActionTypes, PRELOADER } from "./types";

const initialState: AppStatePreloader = {
  isShow: false,
  isPerformingRequest: false,
};

const reducer = (
  state = initialState,
  action: PreloaderActionTypes
): AppStatePreloader => {
  switch (action.type) {
    case AUTHENTICATION.CHANGE_PASSWORD:
    case PRELOADER.SHOW: {
      return {
        ...state,
        isShow: true,
      };
    }
    case AUTHENTICATION.CHANGE_PASSWORD_FAILURE:
    case AUTHENTICATION.CHANGE_PASSWORD_SUCCESS:
    case PRELOADER.HIDE: {
      return {
        ...state,
        isShow: false,
      };
    }

    default:
      return state;
  }
};

export default reducer;
